import * as React from 'react'

import { cn } from '@/lib/utils'

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean
}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <label
      className={cn(
        'text-sm font-medium leading-none text-gray-700',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className
      )}
      ref={ref}
      {...props}
    >
      {children}
      {required && <span className="ml-1 text-black"> (*)</span>}
    </label>
  )
)
Label.displayName = 'Label'

export { Label }
